import React from "react";
import { useIdleSessionTimeout } from '../hooks/useIdleSessionTimeout';
import Header from "../Layout/Header";
import { AccessControlledApp } from './AccessControlledApp';
import AccessControlledPortalCards from "../AppCards/AccessControlledPortalCards";
import SupportSection from "../HelpCard/SupportSection";

const MainAppContent: React.FC = () => {
  // Enable session timeout based on inactivity
  useIdleSessionTimeout();

  return (
    <div className="App">
      <Header />
      <div
        style={{
          display: "flex",
          position: "relative",
          marginTop: "56px",
          flexDirection: "column",
          backgroundColor: "#F6F7FB",
          paddingBottom: "0", // No space needed - footer will be at bottom
        }}
      >
        <AccessControlledApp 
          loadingTimeout={8000}
          autoCheckAccess={true}
          requireAccessCheck={true}
          onAccessDataReceived={(accessData) => {
            console.log('User access data received:', accessData);
          }}
        >
          <div
            style={{
              flex: "1", // Take available space
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            {/* Main Application Content */}
            <AccessControlledPortalCards />
            <SupportSection />
          </div>
        </AccessControlledApp>
        
      </div>
    </div>
  );
};

export default MainAppContent;
